import LoaderWhite from '../../assets/icons/loader-white.gif';

import './LoadingPage.scss';

const LoadingPage = () => {
  return (
    <div className="loading" role="status" aria-live="polite">
      <img
        className="loaderWhite"
        src={LoaderWhite}
        alt=""
        aria-hidden="true"
      />
      <span className="sr-only">Loading</span>
    </div>
  );
};

export default LoadingPage;
